import type { PropsWithChildren } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { Type } from "@similarweb/ui-components";

import { appOsToStoreMap } from "app/pages/sales-intelligence/modules/apps-search-filters/constants";
import type { AppOperatingSystem } from "app/pages/sales-intelligence/modules/apps-search-filters/types/commonFiltersDto";
import { PLATFORM_ICON_NAME } from "app/pages/sales-intelligence/modules/company-analysis/constants/digital-assets";
import type { AppsDigitalAssetRecord } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";
import solutionUrlsService from "app/pages/sales-intelligence/services/solution-urls";

import { StyledCombinedIcon, StyledTextAnchorCell, AppCellWrapper, BadgeWrapper } from "./styles";

type Props = PropsWithChildren<{
    row: AppsDigitalAssetRecord;
}>;

const MarketBadge = ({ market }: { market: AppOperatingSystem }) => (
    <BadgeWrapper>
        <SWReactIcons
            iconName={PLATFORM_ICON_NAME[market]}
            size="12"
        />
    </BadgeWrapper>
);

export const AppCell = ({ row, children }: Props) => {
    return (
        <AppCellWrapper data-automation="digital-assets-app-cell">
            <StyledCombinedIcon
                type="itemIcon"
                iconType={Type.App}
                iconSrc={row.icon}
                badgeComponent={() => <MarketBadge market={row.market} />}
            />

            <StyledTextAnchorCell
                fontVariant="input2"
                href={solutionUrlsService.getAppAnalysisUrl(row.appId, appOsToStoreMap[row.market])}
                target="_blank"
                tooltipContent={children}
            >
                {children}
            </StyledTextAnchorCell>
        </AppCellWrapper>
    );
};
